import styled, { css } from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    margin-bottom: 2rem;
  }

  .profile-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .sheet-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #00000080;
    }
  }
`;

export const PageHeader = styled.div`
  padding: 3.8rem 0;
  padding-left: 5.6rem;
  height: 16rem;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #242424;

  @media (max-width: 1024px) {
    padding: 2rem 4rem;
  }

  @media (max-width: 425px) {
    padding: 2rem;
  }
`;

type HeaderWrapperProps = {
  secondary?: boolean;
};

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  width: 100%;

  @media (max-width: 768px) {
    display: flex;
  }

  @media (max-width: 1024px) {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    flex-direction: row;
    justify-content: space-between;

    ${({ secondary }) =>
      secondary &&
      css`
        flex-direction: column;
        align-items: flex-start;
      `}
  }
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
  letter-spacing: 1.25px;

  @media (max-width: 1024px) {
    width: 48%;
  }
  @media (max-width: 425px) {
    width: fit-content;
  }
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 425px) {
    display: none;
  }
`;

type InfoProps = {
  hide?: boolean;
};

export const InfoButton = styled.button<InfoProps>`
  background: transparent;
  font-size: 0;

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const Info = styled.div`
  display: flex;
  margin-top: 1.4rem;

  @media (max-width: 1024px) {
    margin-top: 0rem;
  }

  /* @media (max-width: 1024px) {
    width: 48%;
  } */

  @media (max-width: 425px) {
    width: fit-content;
  }
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem 5rem;
  margin-bottom: 2rem;
`;

export const InfoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.8rem;
  margin-right: 3rem;

  p {
    margin-left: 0.4rem;
  }
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

export const Section = styled.section`
  margin: 4.2rem 5.8rem;

  @media (max-width: 1024px) {
    margin: 4rem;
  }

  @media (max-width: 425px) {
    margin: 2rem;
  }
`;

export const NewButtonContainer = styled.div`
  flex: 1;
  height: 150%;
  padding-right: 3.8rem;

  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  height: 80%;

  > h1 {
    color: #ffdf22;
  }
`;

export const NewButton = styled.button`
  letter-spacing: 0.95px;
  text-transform: uppercase;
  font-size: 1.9rem;
  font-weight: bold;

  width: 32.8rem;
  height: 5rem;
  background: #ffd503;
  border-radius: 2.5rem;

  @media (max-width: 768px) {
    width: 100%;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const NewButtonLabel = styled.p`
  margin-left: 1.108rem;
`;

export const Message = styled.p`
  color: #fff;
  font-size: 2.2rem;
  padding-top: 15rem;

  text-align: center;

  width: calc(100% - (5.8rem * 2));

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ModalSequenceContainer = styled.div`
  width: 40rem;
`;

export const FieldSet = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  margin-bottom: 3.6rem;
`;

export const FieldSetWrapper = styled.div`
  padding: 0 2.5rem;
`;

export const FieldTitle = styled.p`
  font-size: 2.1rem;
  font-weight: bold;

  margin-bottom: 2rem;
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  padding: 0 1.7rem;
  margin-bottom: 0.6rem;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #000;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#000' : '#fff')};
    }
  }

  > p {
    color: #000;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #000;
    }

    > p {
      color: #000;
    }
  }
`;

export const CardContainer = styled.ul`
  margin-top: 4.3rem;
  width: calc(100% - (5.8rem * 2));

  @media (max-width: 768px) {
    width: 100%;
  }
`;

type RowContainerProps = {
  completeRow?: boolean;
};

export const RowContainer = styled.div<RowContainerProps>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4.4rem;

  max-width: 68.4rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-gap: 0rem;
  }

  ${({ completeRow }) =>
    completeRow &&
    css`
      grid-template-columns: 1fr;
      grid-gap: 0;
    `}
`;

export const InputSet = styled.fieldset`
  border: none;
  margin-bottom: 2.5rem;

  div {
    border-radius: 2rem;
  }
`;

export const InputLabel = styled.label`
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;

  padding: 0.5rem 1.7rem;
`;

export const SecondPageHeader = styled.header`
  width: 100%;
  height: 12rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 3.8rem 5.6rem;
  background: #242424;

  @media (max-width: 1024px) {
    padding: 2rem 4rem;
  }

  @media (max-width: 425px) {
    padding: 2rem;
  }
`;

export const SecondaryHeaderLine = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 1024px) {
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 425px) {
    justify-content: center;
    flex-wrap: nowrap;
  }
`;

export const SecondaryHeaderBackButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;

  font-size: 2.5rem;
  color: #ffdf22;

  @media (max-width: 1024px) {
    width: 48%;
  }

  @media (max-width: 425px) {
    width: auto;
  }

  p {
    margin-left: 0.5rem;
    font-weight: bold;
    letter-spacing: 1.25px;
    text-transform: uppercase;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 425px) {
      margin-left: 0;
    }

    @media (max-width: 425px) {
      display: none;
    }
  }
`;

export const SecondaryHeaderContinueButton = styled.button`
  width: 31.7rem;
  height: 4.4rem;
  background: #ffdf22;
  border-radius: 2.5rem;

  font-size: 1.8rem;
  font-weight: bold;

  @media (max-width: 1024px) {
    width: 48%;
  }

  @media (max-width: 425px) {
    width: 31.7rem;
  }

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const SecondaryHeaderInfo = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 425px) {
    padding-top: 2rem;
    align-items: center;
    justify-content: center;
  }

  div {
    color: #fff;
    font-size: 1.8rem;
    display: flex;

    margin-right: 3rem;
    p {
      margin-left: 0.4rem;
    }
  }
`;

type PowerCreatorProps = {
  active?: boolean;
};

export const PowerCreatorButton = styled.div<PowerCreatorProps>`
  display: flex;
  justify-content: center;
  max-width: 68.4rem;
  margin-bottom: 2.5rem;

  div {
    font-size: 0;
    cursor: pointer;
    padding: 1rem;
    border-radius: 50%;

    background: linear-gradient(115deg, white 0%, #fff0f0 100%) 0% 0% no-repeat
      padding-box;

    ${({ active }) =>
      active &&
      css`
        background: linear-gradient(115deg, #ffdf22 0%, #ffd503 100%) 0% 0%
          no-repeat padding-box;
      `}
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 0.1rem;
  background: #dadada;
  margin-bottom: 2.5rem;
`;

export const PowerCreatorView = styled.div<PowerCreatorProps>`
  display: none;

  ${({ active }) =>
    active &&
    css`
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: 68.4rem;
    `}

  fieldset {
    width: 100%;
    border: none;
    display: flex;
    flex-direction: column;
    margin-bottom: 2.5rem;

    label {
      color: #fff;
      font-size: 1.5rem;
      font-weight: bold;
      padding: 0.5rem 1.7rem;
    }

    div {
      input {
        font-size: 1.5rem;
      }
      height: 3.8rem;
      padding: 0 1.7rem;
    }
  }
`;

export const RecoveryTimeModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 100%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      /* background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box; */
      border-radius: 50px;
      opacity: 1;

      &:first-child {
        color: #000;
      }
      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }

      &:first-child {
        background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%)
          0% 0% no-repeat padding-box;
      }

      &:last-child {
        background: transparent
          linear-gradient(155deg, #b50808 0%, #d90606 100%);
      }
    }
  }
`;

export const FirstScreenHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
